<template>
	<div>
		<div class="view-framework">
			<userLeft></userLeft>
			<div class="view-framework-body">
				<div class="view-framework-main">
					<div class="box">
						<h2 class="box-caption">提现账号</h2>
						<div class="form-filter">
							<div class="form-group">
								<div v-if="!name || !userList.phone">
									<div v-if="name">
										<router-link :to="{path:'/real'}" class="btn btn-default btn-sm btn-square px30">去实名</router-link>
										<span class="text-red">提现需要先实名认证</span>
									</div>
									<div v-if="!userList.phone">
										<router-link :to="{path:'/bindPhone'}" class="btn btn-default btn-sm btn-square px30">去绑定手机</router-link>
										<span class="text-red">提现需要先绑定手机</span>
									</div>
								</div>
								<button  v-if="name && userList.phone"  @click="addAcount()" class="btn btn-primary btn-sm btn-square px30" type="button">添加{{tabIndex==='1'?'支付宝':tabIndex === '2'?'银行卡':'微信'}}</button>
							</div>
						</div>
						<div class="table-responsive">
							  <el-tabs v-model="tabIndex" @tab-click="handleClick">
							    <el-tab-pane label="支付宝" name="1"></el-tab-pane>
							    <el-tab-pane label="银行卡" name="2"></el-tab-pane>
							    <el-tab-pane label="微信" name="3"></el-tab-pane>
							  </el-tabs>
							  <el-table
							    :data="tableData"
							    border
									stripe
							    style="width: 100%">
							    <el-table-column
							      prop="name"
							      label="姓名"
							      width="280">
							    </el-table-column>
									<el-table-column
									  prop="bank_name"
									  label="银行名称"
									  width="180"
										v-if="tabIndex === '2'"
										>
									</el-table-column>
							    <el-table-column
							      :prop="tabIndex === '1'?'account':tabIndex === '2'?'account':'nickName'"
							      :label="tabIndex === '1'?'支付宝账号':tabIndex === '2'?'银行卡卡号':'微信昵称'"
							      width="400">
							    </el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-button
											v-if="tabIndex != '3'"
												size="mini"
												@click="updateAccount(scope.$index, scope.row)">编辑</el-button>
											<el-button
												size="mini"
												type="danger"
												@click="delAccount(scope.$index, scope.row)">删除</el-button>
										</template>
									</el-table-column>
							  </el-table>
						</div>
					</div>
				</div>
			</div>
			<pop ref="addPop" :name="name"></pop>
		</div>
	</div>
</template>

<script>
	import pop from '../common/withdraw/pop.vue'
	export default{
		data(){
			return{
				tabIndex:'1',
				name:"",
				tableData:[],
				userList:[]
			}
		},
		components:{
			pop
		},
		created() {
			var query = this.$route.query;
			this.tabIndex = query.type?query.type:'1';
			this.getUserList()
			this.getUserRealStatus()
		},
		methods:{
			// 添加提现账号
			addAcount(){
				if(this.tabIndex === '1'){
					this.$refs.addPop.addZfb()
				}else if(this.tabIndex === '2'){
					this.$refs.addPop.addBank()
				}else{
					this.$refs.addPop.getQrcode()
				}
			},
			// 个人信息
			getUserList(){
				let token = localStorage.getItem('token')
				this.$api.userInfo({
					token
				}).then(result => {
					if(result.code === 1){
						localStorage.setItem("userInfo",JSON.stringify(result.data))
						this.userList = result.data
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			// 实名信息
			getUserRealStatus(){
				let token = localStorage.getItem('token')
				this.$api.getUserRealStatus({
					token:token,
					type:1
				}).then(res => {
					if(res.code === 1){
						if(res.data.name){
							this.name = res.data.name
							this.getWithdrawList()
						}
					}
				})
			},
			// 提现账号列表
			getWithdrawList(){
				let token = localStorage.getItem('token')
				console.log(this.tabIndex);
				this.$api.getWithdrawList({
					token:token,
					type:this.tabIndex
				}).then(res => {
					if(res.code === 1){
						console.log(res);
						this.tableData = res.data
					}
				})
			},
			handleClick(tab, event) {
				this.getWithdrawList()
			},
			// 编辑提现账号
			updateAccount(index, row) {
				if(this.tabIndex === '1'){
					this.$refs.addPop.updateZfb(row)
				}else if(this.tabIndex === '2'){
					this.$refs.addPop.updateBank(row)
				}
			},
			delAccount(index, row) {
				this.$confirm('删除此提现账号?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if(this.tabIndex === '1'){
						this.delZfb(row.id)
					}else if(this.tabIndex === '2'){
						this.delBank(row.id)
					}else{
						this.delWx(row.id)
					}
				}).catch(() => {

				});

			},
			delZfb(id){
				let token = localStorage.getItem('token')
				this.$api.delWithdrawAli({
					token: token,
					id:id
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							window.location.reload();
						},500)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			delBank(id){
				let token = localStorage.getItem('token')
				this.$api.delWithdrawBank({
					token: token,
					id:id
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							window.location.reload();
						},500)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			delWx(id){
				let token = localStorage.getItem('token')
				this.$api.delWithdrawWx({
					token: token,
					id:id
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							window.location.reload();
						},500)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/user/withdrawAccount.vue